import { Component, Fragment } from 'react';
import { history } from '../../index';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import Grid from '@mui/material/Grid';

class IncidentLookupDetails extends Component {


    viewIncident = (forId) => {
        history.push(`/incidents/${forId}`);
    }

    render() {
        if (!this.props.visible) {
            return null;
        }

        return (
            <Paper>
                <Grid style={{ maxWidth: "600px", marginTop: "10px", marginLeft: "5px" }} container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                    <Grid item xs={4}>
                        <b>Incident Name:</b>
                    </Grid>
                    <Grid item xs={8}>
                        {this.props.searchResult.IncidentName}
                    </Grid>
                    <Grid item xs={4}>
                        <b>FOR ID:</b>
                    </Grid>
                    <Grid item xs={8}>
                        <Button
                            color="primary"
                            variant="text"
                            style={{ justifyContent: "start" }}
                            onClick={e => { this.viewIncident(this.props.searchResult.FORID) }}>{this.props.searchResult.FORID}</Button>
                    </Grid>
                    {(this.props.searchResult.WasMerged) &&
                        <Fragment>
                            <Grid item xs={4}>
                                <b>Was Merged:</b>
                            </Grid>
                            <Grid item xs={8}>Yes</Grid>
                            <Grid item xs={4}>
                                <b>Merged By:</b>
                            </Grid>
                            <Grid item xs={8}>{this.props.searchResult.MergeInfo.MergedByUsername}</Grid>
                            <Grid item xs={4}>
                                <b>Fire Merged On:</b>
                            </Grid>
                            <Grid item xs={8}>{moment(this.props.searchResult.MergeInfo.MergedOnDateTime).format("MM/DD/YYYY h:mm A")}</Grid>
                            <Grid item xs={4}>
                                <b>Record Merged On:</b>
                            </Grid>
                            <Grid item xs={8}>{moment(this.props.searchResult.MergeInfo.RecordMergeDate).format("MM/DD/YYYY h:mm A")}</Grid>
                        </Fragment>
                    }
                </Grid>
            </Paper>
        );
    }
}


export default IncidentLookupDetails;

